document.addEventListener("DOMContentLoaded", function () {
  // Function to initialize lazy loading for videos
  const lazyVideos = document.querySelectorAll(".lazy-load");

  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
  };

  const observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.play(); // Play the video when it becomes visible
      } else {
        entry.target.pause(); // Pause the video when it's not visible
      }
    });
  }, options);

  lazyVideos.forEach((video) => {
    observer.observe(video);
  });
});
